export default {
  "Modal": {
    "CloseModal": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開店前"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自助服務機運營已截止\n想要訂購的話請諮詢櫃檯。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認自助服務機運營時間後使用。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自助服務機運營時間"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上午"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下午"])}
    },
    "HealthyCheck": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["檢查中"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目前無法在自助服務機進行訂單"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請諮詢櫃檯的合夥人。"])}
    },
    "Helper": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["幫助功能"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["很難使用自助服務機嗎？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可使用以下功能。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您可以隨時關閉該功能。"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輪椅模式"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["個子矮或者坐在輪椅上也可以使用。"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["高對比度模式"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["提供幫助視覺不便者的黑白高對比畫面。"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["職員呼叫"])}
    },
    "EMoneySelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子卡餘額確認"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇要確認餘額的電子貨幣。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "EMoneyCheck": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子卡餘額確認"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請將支付二維碼放在條形碼閱讀器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果無法識別二維碼，請亮屏。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["餘額"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
    },
    "EMoneyReady": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["檢查電子貨幣餘額"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["將 Pay 的二維碼放在條形碼閱讀器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二維碼無法讀取時點亮屏幕。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["餘額"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["好的"])}
    },
    "StaffCall": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["職員呼叫"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["要叫店員嗎？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["呼叫後請稍等"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["呼叫"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["呼叫了職員。 請稍等。"])}
    },
    "MenuPersonal": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["過敏/營養信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數量"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要加餐嗎？"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["期權金額"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂貨金額"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["裝進購物車"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["過敏成分"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["該食品與使用右側標示成分的產品在同一製造設施中製造。"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["營養成分"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["熱量\n(kcal)"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["蛋白質\n(g)"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["脂肪\n(g)"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["碳水化合物\n(g)"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["糖分\n(g)"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["反式脂肪\n(g)"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["鹽分\n(mg)"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["咖啡因\n(mg)"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["膽甾醇\n(mg)"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["副菜單"])}
    },
    "OrderSelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇訂購方法。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在店內食用時，請將'店內'帶回去時，請點擊'外賣'。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果選擇外賣的話，不能在店裏吃。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["店內"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外賣"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "MenuEvent": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["推薦菜單"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一起吃會更好"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇商品後，請點擊'放入購物車'按鈕。（可重複）"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["追加金額"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒事。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加"])}
    },
    "Members": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員認證"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請把要結算的會員條形碼放在條形碼閱讀器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請儘量把手機的亮度調亮"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機優惠券"])}
    },
    "MembershipMaster": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员认证"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请用手机号码或条码/QR码进行认证"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机号码"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["条形码/QR码"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只输入手机号码而不输入「-」"])},
      "MSG6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入"])},
      "MSG7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["继续"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除\n全部"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["你是客户吗？"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果正确，请继续"])}
    },
    "MembershipPw": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员密码认证"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入密码"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入密码"])}
    },
    "MembersInfo": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認您的積分。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客戶名"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等級"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積分"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積累"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])}
    },
    "Point": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用積分"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積分可從1000P開始使用。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用的積分不能退款。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算總金額"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可用積分"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入使用積分"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用積分"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])}
    },
    "Card": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信用卡結算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請將卡插入卡口或靠近手機"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請參考以下圖片進行。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["IC卡結算時"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機支付結算時"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["讀卡器"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請將卡一直插入插入口，等到結算完畢爲止。"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請將手機放在讀卡器上,等到結算完畢爲止。"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])}
    },
    "CardReturn": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卡回收"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請把卡收回來"])}
    },
    "Barcode": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二維碼結算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請將二維碼放在條形碼閱讀器上。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請儘量把手機的亮度調亮"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "CashRecipt": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現金收據"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請準確輸入個人及事業者認證信息。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您輸入的信息不另行認證。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機號碼"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只輸入手機號碼而不輸入'-'"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["個人"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["營業者"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全刪除"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意個人信息收集使用同意書及個人信息提供及委託同意書"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現金收據的發行"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["營業執照號"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["僅輸入營業執照號而不輸入 -"])}
    },
    "Alert": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積分累積了。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
    },
    "AlertHome": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回到最初"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您要取消訂購後第一次回去嗎？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["購物車內的商品將被刪除。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回到最初"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒有 kiosk 操作\n返回到第一個屏幕"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輕觸按鈕繼續使用"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["剩餘時間"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["繼續使用"])}
    },
    "AdminLogin": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自助服務機管理器登錄"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請標記電子鑰匙或輸入密碼。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用戶名"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密碼"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全刪除"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
    },
    "PaymentFail": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款失敗"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算失敗。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請諮詢櫃檯。"])}
    },
    "PaymentError": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款錯誤"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算失敗。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請諮詢櫃檯。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "BasketDel": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全刪除"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確定要刪除購物車裏的所有商品嗎？"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["空了菜籃子就回不來了"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "Cash": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現金結算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請把現金投入下面。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請務必確認要返還的零錢。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["小計金額"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["投入金額"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["零錢"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關閉"])}
    },
    "Emoney": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用電子貨幣支付"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇電子貨幣。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交通系統IC"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["樂天Edy"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "EmoneyPay": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用交通系統IC支付"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請把電子貨幣靠近讀卡器。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "PayComplete": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算完畢"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款已正常處理。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["￥"])}
    },
    "QrCode": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用電子貨幣支付"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇電子貨幣。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["梅爾菲"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["樂天Pay"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二維碼結算"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alipay"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WeChat Pay"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PayPay"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LINE Pay"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["au Pay"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["QUOPay"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yucho Pay"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naver Pay"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kakao Pay"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SSG Pay"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smile Pay"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zero pay"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L.PAY"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PAYCO"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Card"])}
    },
    "QrCodePay": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二維碼結算"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請把二維碼靠近條形碼閱讀器。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["把手機屏幕調亮就容易閱讀了。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "Sco": {
      "Basket": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["註冊無條形碼商品"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇您想要購買的\n 商品。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入購買數量。"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除全部"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["追加金額"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["之前"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])},
        "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數量"])}
      },
      "Barcode": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["註冊無條形碼商品"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["想要購買的商品的條形碼一列編號"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["條形碼"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入條形碼序列號"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除全部"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])}
      }
    },
    "Allergy": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["食物過敏列表"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認想要排除的"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["適用"])}
    },
    "Sign": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子簽名"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請簽名後按確認按鈕。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["簽名後點擊簽名完成按鈕才能完成結算。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請在這裏簽名"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算金額"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["簽名完成"])}
    },
    "Membership": {
      "Point": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用會員積分"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员积分最少"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扣除的積分不能退款"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算總金額"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可用積分"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 輸入使用點"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用結算總金額積分"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除全部"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 刪除"])},
        "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 取消"])},
        "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用會員積分"])},
        "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["P開始可以使用。"])},
        "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员积分单位"])},
        "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员积分"])},
        "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可以以P为单位使用。"])},
        "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1次可用限度"])},
        "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是P."])},
        "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用了比结算金额更多的积分。"])},
        "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确定要使用吗?"])},
        "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可使用一次的限度積分"])}
      },
      "Check": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["會員積分信息"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認會員積分信息。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客戶名"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 等級"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 積分"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我只會積分"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用和累積積分"])}
      }
    },
    "Instalment": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇付款方式"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇一次性付款和分期付款時間"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["分期付款手續費、免息優惠等根據信用卡公司的政策而有所不同。 \n請諮詢相關信用卡公司。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇分期付款"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["月"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一次性付款"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
    },
    "Coupon": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機優惠券信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇您想要使用的手機優惠券。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算總金額"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打折"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用手機優惠券"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没关系，按一下按钮继续下一步"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["带优惠券的产品信息"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择要使用优惠券的产品"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换券"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优惠券"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["优惠券条件不符合，不能使用"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有优惠券"])}
    },
    "AlertConfirm": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代币到期需要重新启动应用程序"])}
    },
    "AlertSuccess": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購失敗。"])}
    },
    "Payment": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付款信息传输正在处理中。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在完成交易。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退貨/強制取消 正在處理取消結算"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在處理信用卡取消。"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在進行結算取消中。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在發送付款信息"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在處理完成中"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未完成的付款信息正在处理中。"])}
    },
    "AlramConfirm": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知發送失敗 \n請諮詢職員"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["振動鈴傳輸失敗 。 \n請諮詢職員"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["跳過"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重試"])}
    }
  },
  "User": {
    "Idle": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您好！請選擇訂購方法。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["店內"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外賣"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["移動訂購"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日本語"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["한국어"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ENGLISH"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["繁体中文"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["简体中文"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子卡餘額查詢"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["職員呼叫"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["幫助功能"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["入門"])}
    },
    "Order": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新產品"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折價"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["人氣"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["促銷活動"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["推薦"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["佈景"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["含有過敏成分"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["賣完"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回到最初"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["職員呼叫"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["幫助功能"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["檢查過敏成分"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請勾選想要排除的項目"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["購物籃"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除全部"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合計"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["點菜"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銷售中"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退出管理員模式"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["過敏成分\n 過濾器"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品數量"])},
      "msg22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂單金額"])},
      "msg23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品名"])},
      "msg24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品數量"])},
      "msg25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金額"])},
      "msg26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打開購物車"])},
      "msg27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關閉購物車"])},
      "msg28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隨機登記"])},
      "msg29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手寫回報"])},
      "msg30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["任意登記中。\n請稍等"])},
      "msg31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手遊產品中。\n請稍等"])},
      "msg32": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按國家查看葡萄酒"])},
      "msg33": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇您要查詢的產地"])},
      "msg34": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NewZealand"])},
      "msg35": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Germany"])},
      "msg36": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["USA"])},
      "msg37": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spain"])},
      "msg38": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italy"])},
      "msg39": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chile"])},
      "msg40": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Portugal"])},
      "msg41": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["France"])},
      "msg42": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Australia"])},
      "msg43": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Argentina"])},
      "msg44": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["處理完成"])}
    },
    "OrderCheck": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購明細確認"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積分/折扣"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇付款方式"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇通知"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購方法"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["店內"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外賣"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購明細"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認您訂購的商品。"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可通過下面的箭頭按鈕滾動列表。"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品名"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數量"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稅率"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金額"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購數量"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金額"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金額"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["應付款額"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一步"])}
    },
    "OrderSaving": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["積分/折扣"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇積分及打折手段。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可重複積分/折扣"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中国海会会员"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存圖章"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用優惠券"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購數量"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金額"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金額"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["應付款額"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一步"])}
    },
    "PaySelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇付款方式"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇要進行結算方式。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算只能用一種手段進行。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現款"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信用卡"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子卡"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快捷支付"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快捷支付(Pay)"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["優惠券"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機商品劵"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電子貨幣餘額確認"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購數量"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金額"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已付金額"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["應付款額"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一步"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銀聯卡"])}
    },
    "BellSelect": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇通知"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇要接收指導的通知服務。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["可以在通知和呼叫鈴中選擇。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["菜單準備就緒後，\n您將收到通知談話。"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["準備好菜單後，\n會通過震動鈴通知您。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知對話"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["震動鈴通知"])}
    },
    "BellMobile": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入通知通話信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請準確輸入通知發送的手機號碼。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您輸入的號碼不另行認證。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手機號碼"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["只輸入手機號碼而不輸入'-'"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入完成"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全刪除"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意個人信息收集使用同意書及個人信息提供及委託同意書"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入振動鈴信息"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請正確輸入震動鈴號碼"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["購買的產品信息將發送到 Notification Talk"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入您的手機號碼，享受各種福利"])}
    },
    "MobileFinish": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂單已完成！"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通知通話準備就緒"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["菜單準備好後我們會通過通知通知您。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收據輸出"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確定要打印收據嗎?"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印收據"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不打印"])}
    },
    "PagerFinish": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂單已完成！"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["振動鈴準備完畢"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["準備好菜單後 用震動鈴告訴大家"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收據輸出"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確定要打印收據嗎？"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印收據"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不打印"])}
    },
    "AdultCertification": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成人認證"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["由於未成年人不能購買本產品，因此需要成人身份驗證。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["勾選下面的認證方式後, 準備好認證方式, 點擊Authenticate按鈕。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用 Kakao 進行身份驗證"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用 PASS 進行身份驗證"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["バーコードやQRコードを認識させてください"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話の画面の明るさをできるだけ明るくしてください"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成人認証完了"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成人認証が完了しました\nお支払いを進めてください"])}
    },
    "WineFinish": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂單完成"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您的酒品訂單已完成"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品酒師"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["產品發布準備"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自動售貨機正在準備葡萄酒\n請稍等"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在刪除產品"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打開自動售貨機門，取出酒"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["產品出口完成"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請關閉自動售貨機門"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["酒品銷售已完成\n請取回您的信用卡"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["準備分發酒"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["品酒機正在準備葡萄酒\n請稍等"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["配酒"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請按下品嚐器上的按鈕"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["配酒完成"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["出口機"])},
      "msg98": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重試"])},
      "msg99": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AlimTalk 傳輸和收據打印"])}
    },
    "Pickup": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選擇驗證手段"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認證"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認訂購內容"])},
      "PickupSelect": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認接貨訂購"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請進行認證確認訂購明細。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用QR碼進行認證"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入訂購號"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
      },
      "PickupQRCode": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用QR碼進行認證"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請將手機應用程序上的二維碼放在閱讀器上。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請儘量把手機畫面調亮。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
      },
      "PickupMobile": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入訂購號"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入手機應用程序上的訂購號。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您輸入的號碼不另行認證。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購號碼"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入訂購號"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["同意個人信息收集使用同意書及個人信息提供及委託同意書"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入完成"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完全刪除"])}
      },
      "PickupCheck": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購認證成功"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認訂購內容。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開始準備菜單了"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購號碼"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["賣場名稱"])},
        "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接收時間"])},
        "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["總金額"])},
        "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
        "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購明細正確。"])}
      },
      "PickupCheckError": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂購確認失敗"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請確認認證失敗的原因"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["沒有進行事前結算。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請在訂單上的賣場取貨。"])},
        "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])}
      },
      "PickupFinish": {
        "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認完畢！"])},
        "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請在櫃檯領取商品。"])},
        "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["需要準備商品的時間/n準備完畢後,我會叫您的訂購號碼。"])},
        "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["秒後首先返回畫面。"])}
      }
    },
    "Sco": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品名"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開機"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稅率"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數量"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金額"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 商品未掃描。"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 輸入條形碼"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂單數量"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["訂單金額"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["折扣金額"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合計金額"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待售物品"])}
    },
    "HelperHeight": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["初始化"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上傳屏幕"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卸載屏幕"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按下按鈕，屏幕就可以上下移動了"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結束模式"])}
    },
    "Membership": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会员应用失败。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" 返回上一阶段 。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您要积分吗？"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["积分使用已完成\n\r 请进行剩余金额的结算"])}
    }
  },
  "Admin": {
    "Common": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["發生錯誤。 請諮詢管理員。"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已保存。"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["處理。"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請在管理頁面上解決。"])}
    },
    "AdminHeader": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin Setting"])},
      "menu1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主頁"])},
      "menu2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端管理"])},
      "menu3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銷售管理"])},
      "menu1_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主頁"])},
      "menu2_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端信息"])},
      "menu2_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端設置"])},
      "menu2_3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端監控"])},
      "menu3_1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算明細"])},
      "menu3_2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銷售情況"])}
    },
    "AdminFooter": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理員退出"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["切換用戶"])}
    },
    "AdminLogin": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin Login"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator ID"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter login ID"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter a password"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please check employee information"])}
    },
    "CashierLogin": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收銀員登錄"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自動登錄"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收銀員ID"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密碼"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請選擇ID。"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請輸入密碼。"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登錄"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刪除所有"])}
    },
    "KioskAuth": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Device list"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosk NO."])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosk ID"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosk Name"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticate Progress"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verified"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unauthorized"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticate"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Would you like to authenticate with"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["If you want authenticate a device other than the selected device, you need to reinstall the program."])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verification"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company CD"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tnant CD"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop ID"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shop Name"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pos No"])}
    },
    "AdminHome": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主頁"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開店狀態"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["準備金狀態"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開店"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關門"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速運行"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端監控"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算明細"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端信息"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開店/關店"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端設置"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關閉/結算進行"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入準備金"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開店"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關門"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入準備金"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關閉"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數量"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金額"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合計"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["儲存"])},
      "msg22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
      "msg23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["圓"])},
      "msg24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["個"])},
      "msg25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商品信息確認"])},
      "msg26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取款"])},
      "msg27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在檢查"])},
      "msg28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["檢查窗口"])},
      "msg29": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開放進度"])},
      "msg30": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打開"])},
      "msg31": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["關閉/結算"])},
      "msg32": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在維護期間激活彈出窗口。"])},
      "msg33": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在維護期間關閉彈出窗口。"])},
      "msg34": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開放進度"])}
    },
    "KioskInfo": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端信息"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["區分"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["設定值"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["輸入信息"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输出信息"])}
    },
    "KioskSetting": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端設置"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["區分"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Key"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["設定值"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["設定"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["初始化"])}
    },
    "KioskMonitoring": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端監控"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["終端資源"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["類型"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["網絡"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中央處理器"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["內存"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["硬盤"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新啓動PC"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新啓動App"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["調整日期"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新啓動"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["接口聯動狀態"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["狀態"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["檢查狀態"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["聯動設備狀態/控制"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最後狀態消息"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新啓動了。"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App結尾"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結尾"])}
    },
    "SalesList": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["結算明細"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銷售情況"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["整體"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["普通的"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查詢期間"])},
      "msg7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上週"])},
      "msg8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["這周"])},
      "msg9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上個月"])},
      "msg10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本月"])},
      "msg11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["三個月"])},
      "msg12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現款"])},
      "msg13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信用卡"])},
      "msg14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快捷支付"])},
      "msg15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["其他"])},
      "msg16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])},
      "msg17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索結果"])},
      "msg18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易時間"])},
      "msg19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易編號"])},
      "msg20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["總額"])},
      "msg21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["批准與否"])},
      "msg22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["數據不存在。"])},
      "msg23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
      "msg24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["強制取消"])},
      "msg25": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重印收據"])},
      "msg26": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["請檢查打印的收據。"])},
      "msg27": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易方式"])},
      "msg28": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收据"])}
    },
    "SalesReceipt": {
      "msg1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銷售現狀"])},
      "msg2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["營業日期"])},
      "msg3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查詢"])},
      "msg4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["銷售摘要"])},
      "msg5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打印收據"])},
      "msg6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["得到通知"])}
    }
  }
}